<template>
    <tile>
        <div class="flex flex-col h-full">
            <div class="text-xl flex items-baseline justify-between pl-1">
                Nøkkeltall
            </div>
            <div v-if="profLos" class="h-full overflow-y-auto gap-2 flex flex-col">
                <sidebar-metric-display
                    v-for="metric in profLosMetrics"
                    :key="metric.title"
                    :title="metric.title"
                    :amount="metric.amount"
                    :rate="metric.rate"
                    :description="metric.description"
                />
            </div>
        </div>
    </tile>
</template>

<script setup lang="ts">

import Tile from '@/dashboard/Tile.vue'
import {ProfLosMetric, ProfLosReport} from '@/proflos/ProfLosReport'
import SidebarMetricDisplay from '@/dashboard/tiles/SidebarMetricDisplay.vue'
import {computed} from 'vue'

const profLosMetrics = computed<ProfLosMetric[]>(() => {
    if (!props.profLos) {
        return []
    }
    return [
        props.profLos.operationalIncome(),
        props.profLos.operatingCosts(),
        props.profLos.personnelCosts(),
        props.profLos.contributionMargin(),
        props.profLos.otherOperatingCosts(),
        props.profLos.ebitda(),
        props.profLos.depreciations(),
        props.profLos.ebit(),
        props.profLos.netFinance(),
        props.profLos.netIncome()
    ].filter(metric => {
        if (metric.condition) {
            return metric.condition()
        }
        return true
    })
})

const props = defineProps({
    profLos: {
        type: Object as () => ProfLosReport,
        required: false
    }
})

</script>

<style scoped>

</style>